// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.tableSpecial[data-v-2740c200] table tr:nth-child(1) {\n    line-height: 35px;\n}\n.tableSpecial[data-v-2740c200] .col-divider-left {\n    border-left: 1px solid #ebeef5 !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableSpecial": "tableSpecial",
	"col-divider-left": "col-divider-left"
};
module.exports = ___CSS_LOADER_EXPORT___;
